import { makeStyles } from "@mui/styles";

export const useStyles = makeStyles((theme) => ({
	modalBaseDialogContent: {
		flex: 1,
		padding: theme.spacing(0, 4.5),
		minHeight: "50px",
		overflowY: "hidden",

		[theme.breakpoints.down("sm")]: {
			padding: theme.spacing(0, 3),
			overflowY: "auto",
		},
	},
	modalBaseDialogActions: {
		margin: theme.spacing(1, 0, 1, 0),
		padding: theme.spacing(0, 4),
		[theme.breakpoints.down("sm")]: {
			margin: theme.spacing(3, 0, 1, 0),
			padding: theme.spacing(0, 2.5),
		},
	},
	modalBaseMediumSize: {
		minHeight: "80vh",
		maxHeight: "80vh",
		minWidth: "90vw",
		maxWidth: "90vw",
		display: "flex",
		flexDirection: "column",
	},
	fullScreen: {
		display: "flex !important",
		flexDirection: "column",
		"& .MuiDialog-paper": {
			overflowY: "hidden",
		},
	},
	fullWidth: {
		width: "100%",
	},
	modalBaseAlert: {
		display: "flex",
		alignItems: "flex-start",
		border: "none",
		margin: 0,
		padding: theme.spacing(1, 1.5, 0, 1.5),
		"& .MuiAlert-action": {
			alignSelf: "flex-start",
			paddingLeft: 0,
		},
		"& .MuiAlert-action .MuiSvgIcon-root": {
			fontSize: "2.2rem !important",
			marginTop: theme.spacing(-0.5),
			[theme.breakpoints.down("sm")]: {
				marginRight: theme.spacing(-0.5),
			},
		},
		[theme.breakpoints.down("sm")]: {
			padding: theme.spacing(1, 0, 0, 0),
		},
	},
	modalContent: {
		padding: theme.spacing(0, 3),
	},

	dialogTitle: {
		paddingBottom: theme.spacing(0),
		fontSize: 18,
	},
	dialogContent: {
		marginBottom: theme.spacing(0),
		paddingTop: theme.spacing(0),
		paddingBottom: theme.spacing(0),
	},
	dialogContentMessage: {
		color: theme.palette.text.primary,
		fontSize: "0.875rem",
		opacity: 0.7,
		minHeight: "50px",
	},
	dialogActions: {
		marginBottom: theme.spacing(2),
		paddingRight: theme.spacing(2),
	},
	largeDialogActions: {
		padding: theme.spacing(1, 3, 2, 3),
	},
	alert: {
		border: "none",
		margin: 0,
		padding: 0,
	},
	alertTitle: {
		fontSize: "1.1rem",
	},
	fullWidthButton: {
		width: "100%",
	},
	mediumSize: {
		minHeight: "80vh",
		maxHeight: "80vh",
		minWidth: "90vw",
		maxWidth: "90vw",
	},
	messageList: {
		margin: theme.spacing(1, 0, 2, 0),
		overflowY: "auto",
		maxHeight: "200px",
		[theme.breakpoints.down("sm")]: {
			maxHeight: "50vh",
		},
	},
	modalHistoryDialogContent: {
		flex: 1,
		padding: theme.spacing(4, 4.5, 0, 4.5),
		minHeight: "50px",
		overflowY: "hidden",

		[theme.breakpoints.down("sm")]: {
			padding: theme.spacing(4, 3, 0, 3),
		},
	},
	modalHistoryDialogActions: {
		margin: theme.spacing(1, 0, 1, 0),
		padding: theme.spacing(0, 4, 2, 4),
		[theme.breakpoints.down("sm")]: {
			margin: theme.spacing(2, 0, 2, 0),
			padding: theme.spacing(0, 2.5),
		},
	},
	modalHistoryMediumSize: {
		minHeight: "80vh",
		maxHeight: "80vh",
		minWidth: "90vw",
		maxWidth: "90vw",
		display: "flex",
		flexDirection: "column",
	},
	modalHistoryAlert: {
		display: "flex",
		alignItems: "flex-start",
		border: "none",
		margin: 0,
		padding: theme.spacing(0, 1.5, 0, 1.5),
		"& .MuiAlert-action": {
			alignSelf: "flex-start",
			paddingLeft: 0,
		},
		"& .MuiAlert-action .MuiSvgIcon-root": {
			fontSize: "2.2rem !important",
			marginTop: theme.spacing(-0.5),
			[theme.breakpoints.down("sm")]: {
				marginRight: theme.spacing(-0.5),
			},
		},
		[theme.breakpoints.down("sm")]: {
			padding: theme.spacing(0, 0, 0, 0),
		},
	},
}));
